import { useAuth } from "../App";
import Dashboard from "./Dashboard";
import LandingPage from "./LandingPage";

/** The root route: marketing page for a visitor, deck list for a signed-in user. */
export default function Home() {
  const { user, loading } = useAuth();
  if (loading) return null;
  return user ? <Dashboard /> : <LandingPage />;
}
